import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Heart } from "lucide-react";
import { NAV_LINKS, SITE } from "../../data/site";

export const Header = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/85 backdrop-blur-xl border-b border-black/5 shadow-sm"
                    : "bg-white/0 backdrop-blur-0"
            }`}
        >
            <div className="container-fe flex items-center justify-between py-4">
                <Link
                    to="/"
                    data-testid="header-logo-link"
                    className="flex items-center gap-2.5 group"
                >
                    <div className="relative h-10 w-10 rounded-xl bg-brand-green flex items-center justify-center text-white font-display font-extrabold text-lg shadow-md shadow-brand-green/20 group-hover:rotate-3 transition-transform">
                        F
                        <span className="absolute -right-1 -bottom-1 h-3.5 w-3.5 rounded-full bg-brand-navy ring-2 ring-white"></span>
                    </div>
                    <div className="leading-tight">
                        <div className="font-display font-bold text-brand-navy text-[15px]">
                            Formar Estructura
                        </div>
                        <div className="text-[10px] uppercase tracking-[0.2em] text-brand-green font-bold">
                            Fundación · Ibagué
                        </div>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-1" data-testid="header-nav">
                    {NAV_LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
                            className={({ isActive }) =>
                                `px-3.5 py-2 rounded-full text-sm font-medium transition-colors ${
                                    isActive
                                        ? "text-brand-green bg-brand-green-light"
                                        : "text-brand-navy hover:text-brand-green hover:bg-brand-green-light/60"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-2">
                    <Link to="/voluntariado" data-testid="header-volunteer-cta" className="btn-ghost-pill">
                        Ser voluntario
                    </Link>
                    <Link to="/donar" data-testid="header-donate-cta" className="btn-primary-pill">
                        <Heart size={16} className="fill-white" /> Donar
                    </Link>
                </div>

                <button
                    type="button"
                    onClick={() => setOpen(!open)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Menú"
                    className="lg:hidden h-10 w-10 rounded-full bg-brand-green-light text-brand-navy flex items-center justify-center"
                >
                    {open ? <X size={20} /> : <Menu size={20} />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden bg-white border-t border-black/5 animate-fade-in" data-testid="mobile-menu">
                    <div className="container-fe py-4 flex flex-col">
                        {NAV_LINKS.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                data-testid={`mobile-nav-link-${l.to.replace("/", "") || "home"}`}
                                className={({ isActive }) =>
                                    `py-3 px-3 rounded-lg text-base font-medium ${
                                        isActive ? "text-brand-green bg-brand-green-light" : "text-brand-navy"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <div className="flex flex-col gap-2 pt-3 border-t border-black/5 mt-2">
                            <Link to="/voluntariado" data-testid="mobile-volunteer-cta" className="btn-secondary-pill w-full">
                                Ser voluntario
                            </Link>
                            <Link to="/donar" data-testid="mobile-donate-cta" className="btn-primary-pill w-full">
                                <Heart size={16} className="fill-white" /> Donar
                            </Link>
                        </div>
                    </div>
                </div>
            )}

            {SITE.label_eyebrow}
        </header>
    );
};
